(() => {
  const pilotSelector =
    'product-info.tc-protection-disc-pilot, product-info.tc-simple-protection-pilot, product-info.tc-upgrade-kit-pilot, product-info.tc-upgrade-kit-fallback, product-info.tc-bumper-pilot';
  const mobileQuery = window.matchMedia('(max-width: 749.98px)');

  const initializeGallery = (productInfo) => {
    const viewer = productInfo.querySelector('media-gallery [id^="GalleryViewer-"]');
    const mediaList = viewer?.querySelector('[id^="Slider-Gallery-"]');
    if (!viewer || !mediaList || mediaList.dataset.tcPilotHeightReady === 'true') return;

    let currentSlide = mediaList.querySelector('.product__media-item.is-active');
    let frame = null;

    const setCurrentSlide = (slide) => {
      if (!slide || slide === currentSlide) return;

      currentSlide?.removeAttribute('data-tc-pilot-current');
      currentSlide = slide;
      currentSlide.setAttribute('data-tc-pilot-current', 'true');
    };

    const measureSlide = (slide = currentSlide) => {
      setCurrentSlide(slide);

      if (!mobileQuery.matches) {
        mediaList.style.removeProperty('--tc-active-media-height');
        return;
      }

      const height = Math.ceil(currentSlide?.scrollHeight || 0);
      if (height > 0) mediaList.style.setProperty('--tc-active-media-height', `${height}px`);
    };

    const scheduleMeasure = (slide) => {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = null;
        measureSlide(slide);
      });
    };

    currentSlide?.setAttribute('data-tc-pilot-current', 'true');

    viewer.addEventListener('slideChanged', (event) => scheduleMeasure(event.detail?.currentElement));
    mobileQuery.addEventListener('change', () => scheduleMeasure());
    window.addEventListener('resize', () => scheduleMeasure(), { passive: true });

    const mediaObserver = new ResizeObserver((entries) => {
      const activeEntry = entries.find((entry) => entry.target.closest('.product__media-item') === currentSlide);
      if (activeEntry) scheduleMeasure();
    });

    mediaList.querySelectorAll('.product-media-container').forEach((container) => mediaObserver.observe(container));
    mediaList.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener(
          'load',
          () => {
            if (image.closest('.product__media-item') === currentSlide) scheduleMeasure();
          },
          { once: true }
        );
      }
    });

    mediaList.dataset.tcPilotHeightReady = 'true';
    scheduleMeasure();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId !== productInfo.dataset.section) return;
        window.setTimeout(() => {
          scheduleMeasure(mediaList.querySelector('.product__media-item.is-active') || currentSlide);
        });
      });
    }
  };

  document.querySelectorAll(pilotSelector).forEach(initializeGallery);
})();
